export { DocCabecalho } from './DocPagina';
export { DocTituloSecao } from './DocTituloSecao';
export type { BlocoDocumento, ContextoPaginaDocumento } from './DocumentoPaginado';
export { DocumentoPaginado } from './DocumentoPaginado';
export type { SecaoDocumento } from './EstruturaSecoes';
export { irParaSecao, MarcadorSecao, SumarioDocumento } from './EstruturaSecoes';
